import axios from 'axios';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import { SidebarConsumerRenderProps, withSidebarContext } from 'components/sidebar/SidebarContext';
import { TreatmentsConsumerRenderProps, withTreatmentsContext } from 'components/treatments/TreatmentsContext';
import React, { Fragment } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouterProps, withRouter } from 'react-router';
import { Button } from 'semantic-ui-react';
import { resendEmailVerificationMail } from 'services/interventionBookingServices';
import styled from 'styled-components';
import { PatientInfoDto } from 'ts-types/api.types';


const ResultsPane = styled.div`
  flex: 0 0 auto;
  margin-right: 15px;
  min-width: 15rem;
  max-width: 36rem;

  .patient-info-header {
    font-weight: bold;
    font-size: 1.1rem;
    padding-bottom: .5rem;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 0.5rem;
  }

  .results-container {
    display: grid;
    grid-template-columns: minmax(min-content, 1fr) minmax(3.5rem, max-content);
    row-gap: 0.35rem;
    column-gap: 1.2rem;
    font-size: 1rem;

    .patient-info-property {
      color: #575757;
    }

    .patient-info-value {
      font-weight: bold;
    }

    .home-cdr-button {
      width: fit-content
    }

    .success-message {
      color: darkgreen;
      display: inline-block;
      margin-right: 1rem;
    }
  }
`;

export interface PatientInfoPopUpViewProps extends RouterProps,
    MessageSourceProps,
    PatientConsumerRenderProps,
    TreatmentsConsumerRenderProps,
    SidebarConsumerRenderProps {

  patientId: number;
  patientInfo: PatientInfoDto;
}


const PatientInfoPopUpView = (props: PatientInfoPopUpViewProps) => {

  const {
    patientInfo,
    patientId,
    getMessage
  } = props;

  const cancelTokenSource = axios.CancelToken.source();
  const [successMsg, setSuccessMsg] = React.useState<string | undefined>(undefined);

  const numEmailsSent = patientInfo !== undefined ? patientInfo.numOfVerificationMailsSent : undefined;
  const [numberOfMails, setNumberOfMails] = React.useState<number | undefined>(numEmailsSent);


  const resendEmailVerificationMailFunc = async () => {

    try {
      const response = await resendEmailVerificationMail(patientId, cancelTokenSource);
      setSuccessMsg("Successfully sent email")
      setNumberOfMails(response)
      setTimeout(() => {
        setSuccessMsg(undefined)
      }, 1200);
    } catch (e) {
    }
  }

  if (patientInfo) {
    const verifyEmailStatus = patientInfo.verifyEmailStatus;

    return (
        <ResultsPane onClick={evt => {
          evt.preventDefault();
          evt.stopPropagation()
        }}>
          <div className="patient-info-header">
            <span>{patientInfo.title && `${patientInfo.title} `}{patientInfo.name} {patientInfo.firstName}</span>
            <span style={{float: "right"}}>[{patientInfo.id}]</span>
          </div>
          <div className="results-container">
            {
                (verifyEmailStatus === "PENDING" || verifyEmailStatus === "DECLINED") &&
                <>
                  <Button
                      className="home-cdr-button"
                      size="mini"
                      compact
                      basic
                      color="grey"
                      content={getMessage("button.resend.verification.email")}
                      onClick={resendEmailVerificationMailFunc}/>
                  <div/>
                </>
            }

            {
                successMsg &&
                <div className="success-message">
                  {successMsg}
                </div>
            }
            <div className="patient-info-property">
              {getMessage("patient.numberOfSentMails")}:
            </div>
            <div className="patient-info-value">
              {numberOfMails}
            </div>
            <div className="patient-info-property">
              {getMessage("patient.status")}:
            </div>
            <div className="patient-info-value">
              {verifyEmailStatus !== null
                  ? getMessage(`patientCentral.overview.row.verifyEmailStatus.${verifyEmailStatus}`)
                  : ""
              }
            </div>
            <div className="patient-info-property">
              {getMessage("patient.name")}:
            </div>
            <div className="patient-info-value">
              {patientInfo.name} {patientInfo.firstName}
            </div>
            {patientInfo.companyName &&
                <Fragment>
                  <div className="patient-info-property">
                    {getMessage("patient.companyName")}:
                  </div>
                  <div className="patient-info-value">
                    {patientInfo.companyName}
                  </div>
                </Fragment>
            }

            <Fragment>
              <div className="patient-info-property">
                {getMessage("patient.email")}:
              </div>
              <div className="patient-info-value">
                {patientInfo.email || ""}
              </div>
            </Fragment>

            <div className="patient-info-property">
              {getMessage("mandate")}:
            </div>
            <div className="patient-info-value">
              {patientInfo.mandateName}, {patientInfo.mandateCity}
            </div>
          </div>
        </ResultsPane>
    );
  }

  return <div></div>;
};

export default withRouter(
    withMessages(
        withPatientContext(
            withTreatmentsContext(withSidebarContext(PatientInfoPopUpView)))));
